module.exports = __webpack_public_path__ + "static/media/vi-VN.d442167f.md";